<template>
    <div class="owl-carousel gallery-slider owl-theme">
        <Carousel :wrap-around="true">
            <Slide v-for="item in galleryImages" :key="item.id">    
                <a v-for="(image, index) in galleryImages"  :key="index" @click="() => show(index)" 
                    class="corner-radius-10" href="javascript:void(0);" data-fancybox="gallery3">
                    <img class="img-fluid corner-radius-10" alt="Image" 
                    :src="require(`@/assets/img/gallery/gallery2/${image.src}`)">
                </a>
            </Slide>
            <template #addons>
                <Navigation />
            </template>
        </Carousel>
    </div>

    <vue-easy-lightbox :visible="visible" :index="index" :imgs="galleryImages.map((image) => ({
        src: require(`@/assets/img/gallery/gallery2/${image.src}`),
    }))" @hide="visible = false" @on-prev="handlePrev" @on-next="handleNext">
    </vue-easy-lightbox>
</template>
<script>
import { Carousel, Navigation, Pagination, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import VueEasyLightbox from "vue-easy-lightbox";
export default {
    data() {
        return {
            visible: false,
                index: 0,
                galleryImages: [
                {
                    src: "gallery-thumb-01.jpg",
                },
                {
                    src: "gallery-thumb-02.jpg",
                },
                {
                    src: "gallery-thumb-03.jpg",
                },
            ],
        }
    },
    components: {
        Carousel,
        Slide,
        Navigation,
        Pagination,
        VueEasyLightbox
    },
    methods: {
        show(index) {
            this.index = index;
            this.visible = true;
        },
        handlePrev(oldIndex, newIndex) { },
        handleNext(oldIndex, newIndex) { },
    },
}
</script>